import React from "react";
import { NavLink, Outlet } from "react-router-dom";

function Settings() {
  return (
    <>
      <div className="sub-nav">
        <div className="sub-nav-container">
          <NavLink
            to="categories"
            className={({ isActive }) =>
              `sub-nav-item ${isActive ? "sub-nav-item-active" : ""}`
            }
          >
            Categories
          </NavLink>
          <NavLink
            to="syllabus"
            className={({ isActive }) =>
              `sub-nav-item ${isActive ? "sub-nav-item-active" : ""}`
            }
          >
            Syllabus &amp; Subjects
          </NavLink>
          <NavLink
            to="cities"
            className={({ isActive }) =>
              `sub-nav-item ${isActive ? "sub-nav-item-active" : ""}`
            }
          >
            Cities
          </NavLink>
          <NavLink
            to="profession"
            className={({ isActive }) =>
              `sub-nav-item ${isActive ? "sub-nav-item-active" : ""}`
            }
          >
            Profession
          </NavLink>
          <NavLink
            to="source"
            className={({ isActive }) =>
              `sub-nav-item ${isActive ? "sub-nav-item-active" : ""}`
            }
          >
            Source
          </NavLink>
        </div>
      </div>
      <Outlet />
    </>
  );
}

export default Settings;
